import { useCancelPolicy } from "@/components/features/_hooks/use-cancel-policy/use-cancel-policy";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionCancelPolicy = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { cancelPolicy } = viewModel;

	return useCancelPolicy({ cancelPolicy, onSetViewModel });
};
